import React from 'react';

import {RestrictionEnzymeDropdown} from 'molbio/components/RestrictionEnzymeDropdown';
import {NO_ENZYME_SENTINEL} from 'molbio/enzymes/EnzymeConstants';
import EnzymeConstants from 'molbio/enzymes/EnzymeConstants';
import {getEnzymeByName, isDoubleCutterEnzyme} from 'molbio/enzymes/EnzymeUtil';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

interface BulkAssemblyTableRestrictionEnzymeSelectorProps {
  isDisabled: boolean;
  typedValue: TypedValue | null;
  onUpdate: (typedValue: TypedValue) => void;
}

function getValidRestrictionEnzymeId(typedValue: TypedValue | null): number | null {
  if (typedValue == null || typedValue.type !== BaseTypedValueType.STRING) {
    return null;
  }
  const enzyme = getEnzymeByName(typedValue.rawValue);
  return enzyme != null && !isDoubleCutterEnzyme(enzyme) ? enzyme.id : null;
}

export default function BulkAssemblyTableRestrictionEnzymeSelector({
  typedValue,
  onUpdate,
  isDisabled,
}: BulkAssemblyTableRestrictionEnzymeSelectorProps): JSX.Element {
  const maybeRestrictionEnzymeId = getValidRestrictionEnzymeId(typedValue);
  return (
    <RestrictionEnzymeDropdown
      allowedRestrictionEnzymeIds={EnzymeConstants.enzymes
        .filter((enzyme) => !isDoubleCutterEnzyme(enzyme))
        .map((enzyme) => enzyme.id)}
      isDisabled={isDisabled}
      restrictionEnzymeId={maybeRestrictionEnzymeId ?? NO_ENZYME_SENTINEL}
      shouldAllowNull={true}
      updateRestrictionEnzymeId={(restrictionEnzymeId) => {
        onUpdate({type: BaseTypedValueType.STRING, rawValue: restrictionEnzymeId.toString()});
      }}
    />
  );
}
